export enum CameraFrustum {
  PERSPECTIVE,
  ORTHOGRAPHIC
}
